const packageVersion = "0.6.2";
const Config = {
    DEBUG: false,
    LIB_VERSION: packageVersion,
    LIB_NAME: 'browser-common',
    JS_SDK_VERSION: packageVersion
};
const config = Config;
export { config as default };
